import {
  API_HOST,
  API_IMG_HOST,
  API_HOST_JAVA_SET
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import Vueaxios from 'vue-axiosp'
const axiosPhp = axios.create({
  baseURL: API_HOST
})
// axiosPhp.defaults.baseURL = API_HOST
axiosPhp.defaults.timeout = 1000 * 15
axiosPhp.defaults.headers.authKey = Lockr.get('authKey')
axiosPhp.defaults.headers.sessionId = Lockr.get('sessionId')
axiosPhp.defaults.headers['Content-Type'] = 'application/json'
axiosPhp.defaults.paramsSerializer = function (params) {
  return Qs.stringify(params)
}

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}

// 返回处理
axiosPhp.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code == 101) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('firstRoutePath')
    Lockr.rm('userInfo')
    console.log('删除了对象yunzhong.js')
    // // 跳转到登录页
    // router.push({path: '/login'})
    return response
  } else if (response.data.code > 101) {
    //_g.toastMsg('error', response.data.error)
    return response
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})
// 添加请求拦截器
axiosPhp.interceptors.request.use(config => {
  removePending(config) // 在一个ajax发送前执行一下取消操作
  config.cancelToken = new CancelToken((c) => {
    // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
    pending.push({
      u: config.url + '&' + config.method,
      f: c
    })
  })
  return config
}, error => {
  return Promise.reject(error)
})

// 券管理
export function getCoupons (page, search) {
  let url = 'yunzhong/coupon'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 券列表 下线
export function stopCoupons (id) {
  let url = 'yunzhong/coupon/disable/' + id
  return axiosPhp.get(url)
}
// 券列表 发布
export function enableCoupons (id) {
  let url = 'yunzhong/coupon/enabled/' + id
  return axiosPhp.get(url)
}
// 券列表 删除
export function deleteCoupons (id) {
  let url = 'yunzhong/coupon/' + id
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}
// 追加投放量
export function addCouponNumber (id, put_number) {
  let url = 'yunzhong/coupon/append/' + id + '/' + put_number
  return axiosPhp.get(url)
}
// 获取群组
export function getGroups () {
  let url = API_HOST_JAVA_SET + 'userGroup/searchListByPage?modelId=216&pageNum=1&pageSize=10000&name=&groupId='
  return axiosPhp.get(url)
}
// 创建券
export function createCoupons (data) {
  let url = 'yunzhong/coupon'
  return axiosPhp.post(url, data)
}
// 券详情
export function getCouponsDetail (id) {
  let url = 'yunzhong/coupon/' + id
  return axiosPhp.get(url)
}
// 编辑券
export function editCoupons (id, data) {
  let url = 'yunzhong/coupon/' + id
  return axiosPhp.put(url, data)
}
// 券统计
export function getCouponCodes (id, page, search) {
  let url = 'yunzhong/coupon/codes/' + id
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 券下载
export function downloadCoupons (id) {
  let url = 'yunzhong/coupon/download/' + id
  return axiosPhp.get(url)
}
// 券统计 导出
export function exportCoupons (id, search) {
  let url = 'yunzhong/coupon/codes_export/' + id
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}

// 券审核-列表
export function getCouponCodesApprovelist (page, search) {
  let url = 'yunzhong/coupon/codesapprovelist'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
//审核
export function couponCodesApprove (ids) {
  let url = 'yunzhong/coupon/codesapprove'
  return axiosPhp.get(url, {
    params: {
      ids: ids,
    }
  })
}
// 券-二维码下载
export function qrcodeDownload (id) {
  let url = 'yunzhong/coupon/qrcode_download/' + id
  return axiosPhp.get(url)
}